var map = {
	"./Dip.jpg": 2016,
	"./Dipraj Dhar logo.png": 1679,
	"./address_image.svg": 8415,
	"./animated_logo.svg": 4838,
	"./aspire.png": 3205,
	"./blogs_image.svg": 1108,
	"./brain.jpeg": 2640,
	"./british.png": 2938,
	"./ccs.png": 9902,
	"./cloud_infrastructure.svg": 5820,
	"./codeInLogo.png": 9384,
	"./codealpha.jpeg": 5907,
	"./contactMail.png": 3914,
	"./coursera_logo.png": 8857,
	"./data_science.svg": 8712,
	"./delhivery_logo.png": 7311,
	"./developerActivity.svg": 9504,
	"./dsc_logo.png": 3979,
	"./education.svg": 1803,
	"./experience.svg": 1071,
	"./feelingProud.svg": 2677,
	"./freecopy_logo.png": 1434,
	"./fullstack.svg": 1272,
	"./gcp_logo.png": 4375,
	"./github_logo.png": 9214,
	"./googleAssistant.jpg": 3440,
	"./googleAssistant.svg": 9650,
	"./google_logo.png": 6038,
	"./hp.png": 3875,
	"./ibm_logo.png": 5539,
	"./iit.jpeg": 3702,
	"./intel_logo.jpg": 1021,
	"./iu_logo.png": 8291,
	"./jsFramework.svg": 4406,
	"./legato_logo.png": 7147,
	"./manOnTable.svg": 3350,
	"./microsoft_logo.png": 3953,
	"./miet.png": 9794,
	"./nstu-1.png": 4765,
	"./programmer.svg": 2075,
	"./projects_image.svg": 5739,
	"./pwa.png": 7399,
	"./saayaHealthLogo.png": 4123,
	"./simpli.png": 1849,
	"./talksCardBack.svg": 7175,
	"./talksCardBackAlt.svg": 6740,
	"./ui_ux_design.svg": 7880
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;